import './LogoutModal.scss';
import { Typography } from 'antd';
import LoginFooterSVG from '../../assets/login/login-footer';
import AlkemyLogo from '../../assets/alkemy-logo';
import { t } from '../../i18n/i18n';

const LogoutModal = ({ children }) => {
  const { Text } = Typography;

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light position-relative">
      <div className="d-flex flex-column position-absolute align-items-center p-4 shadow bg-white logout-modal-inner">
        <AlkemyLogo addClass="w-60 w-md-33" />
        <Text className="text-secondary text-center">{t('ALKEMY_LOGO_DESCRIPTION')}</Text>
        {children}
      </div>
      <LoginFooterSVG viewBox="0 140 1440 150" />
    </div>
  );
};

export default LogoutModal;
